<template>
  <v-form v-model="dataIsValid">
    <v-row>
      <!--title-->
      <v-col cols="12" md="10" offset-md="1">
        <div class="mb-3 body-1 font-weight-medium" v-if="!editDisable">
          Введите данные документа удостоверяющего Вашу личность
        </div>
      </v-col>
      <!--end of title-->
      <!--2 column form-->
      <!--col 1-->
      <v-col cols="6" md="4" offset-sm="1">
        <!--column inner-->
        <div class="mb-3 body-1 font-weight-medium">Вид документа: *</div>
        <v-select :items="docs"
                  v-model="doc"
                  :disabled="editDisable"
                  outlined></v-select>

        <div class="mb-3 body-1 font-weight-medium">Серия документа: *</div>
        <v-text-field
          outlined
          v-mask="'####'"
          v-model="series"
          :rules="seriesRules"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Номер документа: *</div>
        <v-text-field
          outlined
          v-model="number"
          v-mask="'######'"
          :rules="numberRules"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Кем выдан: *</div>
        <v-text-field
          outlined
          v-model="issuer"
          :rules="notEmptyRule"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Дата выдачи: *</div>

        <input-date-picker v-model="issueDate"
                           :disabled="editDisable"
                           :rules="notEmptyRule"></input-date-picker>

        <!--end of column inner-->
      </v-col>
      <!--col 2-->
      <v-col cols="6" md="4" offset-sm="2">
        <!--column inner-->

        <div class="mb-3 body-1 font-weight-medium">Код подразделения: *</div>
        <v-text-field
          outlined
          v-model="unitCode"
          v-mask="'######'"
          :rules="unitCodeRules"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Дата рождения: *</div>
        <input-date-picker v-model="birthDate"
                           :disabled="editDisable"
                           :rules="notEmptyRule"></input-date-picker>

        <div class="mb-3 body-1 font-weight-medium">Место рождения: *</div>
        <v-text-field
          outlined
          v-model="birthPlace"
          :rules="notEmptyRule"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">ИНН:</div>
        <v-text-field
          outlined
          :rules="length12"
          :disabled="editDisable"
          v-mask="'############'"
          v-model="inn"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Телефон для связи: *</div>
        <v-text-field
          outlined
          v-model="phone"
          :disabled="editDisable"
          v-mask="'+7 (###) ###-##-##'"
          :rules="notEmptyRule.concat(length18)"
        ></v-text-field>

        <!--end of column inner-->
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
    import { mask } from 'vue-the-mask'
    import InputDatePicker from '../../common/InputDatePicker'
    import {mapState} from 'vuex'

    export default {
        directives: {
            mask
        },
        props: ['income', 'document'],
        components: {
            InputDatePicker,
        },
        data: () => ({
            // DATA
            docs: ['Паспорт'],
            doc: 'Паспорт',
            series: '',
            number: '',
            issuer: '',
            issueDate: '',
            unitCode: '',
            birthDate: '',
            birthPlace: '',
            dataIsValid: false,
            inn: '',
            phone: '',
            // FORM SETTINGS
            notEmptyRule: [
                value => !!value || 'Поле обязательно'
            ],
            seriesRules: [
                value => !!value || 'Поле обязательно',
                value => (value.length === 4) || 'Ожидаемая длина 4 символа'
            ],
            numberRules: [
                value => !!value || 'Поле обязательно',
                value => (value.length === 6) || 'Ожидаемая длина 6 символов'
            ],
            unitCodeRules: [
                value => !!value || 'Поле обязательно',
                value => (value || '').length <= 6 || 'Не более 6 символов'
            ],
            length10: [
                value => !value || value && value.length === 10 || 'Введите корректный номер'
            ],
            length12: [
                value => !value || value && value.length === 12 || 'Введите корректный номер'
            ],
            length18: [
                value => value.length === 18 || 'Введите корректный номер'
            ]
        }),
        computed : {
          ...mapState({
            editDisable: state => state.statements.editDisable
          })
        },
        methods: {
            transferData () {
           //   console.log(this.series)
                this.$emit('transfer', {
                    series: String(this.series),
                    number: String(this.number),
                    issuer: this.issuer,
                    issueDate: new Date(this.issueDate).getTime(),
                    unitCode: this.unitCode,
                    birthDate: new Date(this.birthDate).getTime(),
                    birthPlace: this.birthPlace,
                    inn: String(this.inn),
                    phone: this.phone
                })
            }
        },
        created () {
            let keys = Object.keys(this.income)
            keys.forEach(key => {
                this[key] = this.income[key]
            })
        },
        watch: {
            dataIsValid: {
                immediate: true,
                handler: function (value) {
                    this.$emit('lockFwdBtn', !value)
                }
            }
        },
      mounted () {
          if (this.document) {
            this.series = this.document.series
            this.issuer = this.document.issuer
            this.number = this.document.number
            this.issueDate = this.document.issueDate
            this.unitCode = this.document.unitCode
            this.birthDate = this.document.birthDate
            this.birthPlace = this.document.birthPlace
            this.dataIsValid = this.document.dataIsValid
            this.inn = this.document.inn
            this.phone = this.document.phone
          }

      }
    }
</script>
